import React from 'react'

const DashboardIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_990_1224)">
        <path
          d="M10.45 15.5C10.8667 15.9167 11.3917 16.1123 12.025 16.087C12.6583 16.0623 13.1167 15.8333 13.4 15.4L19 7L10.6 12.6C10.1667 12.9 9.92933 13.354 9.888 13.962C9.846 14.5707 10.0333 15.0833 10.45 15.5ZM5.1 20C4.73333 20 4.396 19.9207 4.088 19.762C3.77933 19.604 3.53333 19.3667 3.35 19.05C2.91667 18.2667 2.58333 17.4543 2.35 16.613C2.11667 15.771 2 14.9 2 14C2 12.6167 2.26267 11.3167 2.788 10.1C3.31267 8.88333 4.025 7.825 4.925 6.925C5.825 6.025 6.88333 5.31233 8.1 4.787C9.31667 4.26233 10.6167 4 12 4C13.3667 4 14.65 4.25833 15.85 4.775C17.05 5.29167 18.1 5.996 19 6.888C19.9 7.77933 20.6167 8.82067 21.15 10.012C21.6833 11.204 21.9583 12.4833 21.975 13.85C21.9917 14.7667 21.8877 15.6627 21.663 16.538C21.4377 17.4127 21.0917 18.25 20.625 19.05C20.4417 19.3667 20.196 19.604 19.888 19.762C19.5793 19.9207 19.2417 20 18.875 20H5.1Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default DashboardIcon
